import {} from "@alchemy/aa-core";
import {} from "viem";
import { getThreshold } from "./actions/getThreshold.js";
import { isOwnerOf } from "./actions/isOwnerOf.js";
import { proposeUserOperation } from "./actions/proposeUserOperation.js";
import { readOwners } from "./actions/readOwners.js";
import { signMultisigUserOperation } from "./actions/signMultisigUserOperation.js";
import { multisigPluginActions as multisigPluginActions_, } from "./plugin.js";
import {} from "./types.js";
export const multisigPluginActions = (client) => ({
    ...multisigPluginActions_(client),
    readOwners: (args) => readOwners(client, args),
    isOwnerOf: (args) => isOwnerOf(client, args),
    getThreshold: (args) => getThreshold(client, args),
    proposeUserOperation: (args) => proposeUserOperation(client, args),
    signMultisigUserOperation: (params) => signMultisigUserOperation(client, params),
});
//# sourceMappingURL=extension.js.map